module.exports = __webpack_public_path__ + "img/logo-kemendag.5881e489.png";